var render = function render(_c,_vm){return _c('portal-target',{attrs:{"name":"body"}})
}
var staticRenderFns = []

export { render, staticRenderFns }